import { createEvents } from 'micro-typed-events';

// For conveniency we create some global event channels for the app
const AppGlobalEvents = {
  pathnameChange: createEvents<string>(),
};

export default AppGlobalEvents;
